"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  AccountingCoins: ['accounting-coins', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.250 8.250 A7.500 7.500 0 1 0 23.250 8.250 A7.500 7.500 0 1 0 8.250 8.250 Z', 'M6.375,14.092a1.341,1.341,0,0,0,.843,1.245l2.064.826a1.342,1.342,0,0,1-.5,2.587H6.75', 'M8.25 20.25L8.25 18.75', 'M5.281,8.867a7.5,7.5,0,1,0,9.853,9.852', 'M17.25,5.25H15.217a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H14.25', 'M15.75 5.25L15.75 3.75', 'M15.75 12.75L15.75 11.25']],
  AccountingAbacus: ['accounting-abacus', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 0.750 L22.500 0.750 L22.500 23.250 L1.500 23.250 Z', 'M7.5 0.75L7.5 3.75', 'M7.5 6.75L7.5 12.75', 'M7.5 20.25L7.5 23.25', 'M5.250 3.750 L9.750 3.750 L9.750 6.750 L5.250 6.750 Z', 'M5.250 12.750 L9.750 12.750 L9.750 15.750 L5.250 15.750 Z', 'M5.250 17.250 L9.750 17.250 L9.750 20.250 L5.250 20.250 Z', 'M16.5 23.25L16.5 20.25', 'M16.5 17.25L16.5 11.25', 'M16.5 3.75L16.5 0.75', 'M14.250 17.250 L18.750 17.250 L18.750 20.250 L14.250 20.250 Z', 'M14.250 8.250 L18.750 8.250 L18.750 11.250 L14.250 11.250 Z', 'M14.250 3.750 L18.750 3.750 L18.750 6.750 L14.250 6.750 Z', 'M16.5 6.75L16.5 8.25', 'M7.5 15.75L7.5 17.25']],
  AccountingCalculator1: ['accounting-calculator-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.652,23.25H4.348A1.347,1.347,0,0,1,3,21.9V5.25H21V21.9A1.347,1.347,0,0,1,19.652,23.25Z', 'M12 5.25L12 23.25', 'M3 14.25L21 14.25', 'M7.5 8.25L7.5 11.25', 'M6 9.75L9 9.75', 'M9 17.25L6 20.25', 'M6 17.25L9 20.25', 'M15 9.75L18 9.75', 'M15 17.25L18 17.25', 'M15 20.25L18 20.25', 'M21,5.25H3v-3A1.5,1.5,0,0,1,4.5.75h15A1.5,1.5,0,0,1,21,2.25Z']],
  AccountingCalculator: ['accounting-calculator', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.750 L20.250 0.750 L20.250 23.250 L3.750 23.250 Z', 'M6.750 3.750 L17.250 3.750 L17.250 8.250 L6.750 8.250 Z', 'M7.875,12a.375.375,0,1,1-.375.375A.375.375,0,0,1,7.875,12', 'M12.156,12a.375.375,0,1,1-.375.375A.375.375,0,0,1,12.156,12', 'M16.125,12a.375.375,0,1,1-.375.375A.375.375,0,0,1,16.125,12', 'M7.875,15.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M12.156,15.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M16.125,15.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M7.875,19.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M12.156,19.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M16.125,19.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  AccountingDocument: ['accounting-document', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,21.75a1.5,1.5,0,0,1-1.5,1.5H3.75a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,3.75.75H14.379a1.5,1.5,0,0,1,1.06.439l5.872,5.872a1.5,1.5,0,0,1,.439,1.06Z', 'M21.75,8.25h-6a1.5,1.5,0,0,1-1.5-1.5v-6', 'M6.2,11.594a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547S9.2,9.376,8.062,9.376,6,8.683,6,7.828s.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M8.062 12.469L8.062 13.5', 'M8.062 5.25L8.062 6.281', 'M12 15L18 15', 'M6.75 19.5L18 19.5']],
  AccountingInvoice: ['accounting-invoice', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,21.75a1.5,1.5,0,0,1-1.5,1.5H3.75a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,3.75.75H14.379a1.5,1.5,0,0,1,1.06.439l5.872,5.872a1.5,1.5,0,0,1,.439,1.06Z', 'M21.75,8.25h-6a1.5,1.5,0,0,1-1.5-1.5v-6', 'M5.642,9.344a2.221,2.221,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547S8.639,7.126,7.5,7.126,5.438,6.433,5.438,5.578,6.361,4.031,7.5,4.031a2.221,2.221,0,0,1,1.858.875', 'M7.5 10.219L7.5 11.25', 'M7.5 3L7.5 4.031', 'M5.250 14.250 L18.750 14.250 L18.750 20.250 L5.250 20.250 Z', 'M5.25 17.25L18.75 17.25', 'M9.75 14.25L9.75 20.25', 'M14.25 14.25L14.25 20.25']],
  CalculatorApp: ['calculator-app', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.000 L21.000 3.000 L21.000 21.000 L3.000 21.000 Z', 'M12 3L12 21', 'M3 12L21 12', 'M7.5 6L7.5 9', 'M6 7.5L9 7.5', 'M9 15L6 18', 'M6 15L9 18', 'M15 7.5L18 7.5', 'M15 15L18 15', 'M15 18L18 18']],
  AccountingInvoiceMail: ['accounting-invoice-mail', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.5,12.88V2.25A1.5,1.5,0,0,0,18,.75H6a1.5,1.5,0,0,0-1.5,1.5V12.88', 'M21.284,11.465a.75.75,0,0,1,1.216.587v9.7a1.5,1.5,0,0,1-1.5,1.5H3a1.5,1.5,0,0,1-1.5-1.5v-9.7a.75.75,0,0,1,1.216-.587l7.431,5.894a3,3,0,0,0,3.706,0Z', 'M15.808 15.808L18.75 18.75', 'M8.192 15.808L5.25 18.75', 'M12.2,10.094a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547S15.2,7.876,14.062,7.876,12,7.183,12,6.328s.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M14.062 10.969L14.062 12', 'M14.062 3.75L14.062 4.781', 'M7.5 4.5L9 4.5', 'M7.5 7.5L9 7.5', 'M7.5 10.5L9 10.5']],
  AccountingCalculator2: ['accounting-calculator-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.375,17.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M19.125,17.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M15.375,20.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M19.125,20.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M20.25,13.75c0,.353-.214.5-.429.5H14.679c-.215,0-.428-.164-.428-.518V11.75c0-.354.214-.5.429-.5h5.142c.215,0,.429.146.429.5Z', 'M11.250 8.250 L23.250 8.250 L23.250 23.250 L11.250 23.250 Z', 'M4.125,3.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M8.25,12.75h-6a1.5,1.5,0,0,1-1.5-1.5v-9A1.5,1.5,0,0,1,2.25.75h16.5a1.5,1.5,0,0,1,1.5,1.5v3', 'M7.905,8.256a3,3,0,1,1,5.267-2.87']],
  AccountingInvoiceHand: ['accounting-invoice-hand', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.214,9.344a2.221,2.221,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547S9.211,7.126,8.072,7.126,6.01,6.433,6.01,5.578s.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M8.072 10.219L8.072 11.25', 'M8.072 3L8.072 4.031', 'M23.25,20.986,21.76,18.75V13.5c0-2-3.8-4.139-5.25-5.25', 'M18.44,14.794,14.792,11.87a1.3,1.3,0,0,0-1.843,1.843L16.482,17.7v2.5c0,1.181,1.688,3.045,1.688,3.045', 'M13.51,23.25H2.134A1.375,1.375,0,0,1,.76,21.875V2.125A1.375,1.375,0,0,1,2.134.75h13A1.376,1.376,0,0,1,16.51,2.125V13.247', 'M10.51,14.25h-6a.75.75,0,0,0-.75.75v4.5a.75.75,0,0,0,.75.75h9', 'M3.76 17.25L12.01 17.25', 'M8.26 14.25L8.26 20.25']]
};
exports["default"] = _default;